import { render, staticRenderFns } from "./BadMood.vue?vue&type=template&id=604b7074&scoped=true&"
import script from "./BadMood.vue?vue&type=script&lang=js&"
export * from "./BadMood.vue?vue&type=script&lang=js&"
import style0 from "./BadMood.vue?vue&type=style&index=0&id=604b7074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b7074",
  null
  
)

export default component.exports